import Axios from 'axios'
import { pick } from 'lodash'

const axios = Axios.create({
  headers: {
    authorization: 'Bearer dev__j5hjvfd89034kdsasd112092493uas'
  },
  baseURL: 'https://api.voiss.cc/'
})

export async function storyStart (storyId, opts = {}) {
  const otherParams = pick(opts, [
    'audio',
    'audioID',
    'userId',
    'current',
    'text',
    'from',
    'withText'
  ])
  const data = {
    interactiveID: storyId,
    ...otherParams
  }
  const res = await axios.post('/pa-news/story', data)
  return res.data
}

export async function storyContinue (storyId, opts = {}) {
  const fd = new FormData()
  const keys = [
    'audio',
    'audioID',
    'userId',
    'current',
    'text',
    'from',
    'withText'
  ]
  for (const key of keys) {
    const value = opts[key]
    if (value) {
      if (typeof value === 'object') {
        if (value instanceof Blob) {
          fd.append(key, value)
        } else {
          fd.append(key, JSON.stringify(value))
        }
      } else {
        fd.append(key, value)
      }
    }
  }
  fd.append('interactiveID', storyId)
  console.log(fd)
  console.log(opts)
  const res = await axios.post('/pa-news/story', fd)
  return res.data
}
